import { useEffect, useState } from 'preact/hooks';

import { Icon24Cancel } from '@vkontakte/icons';
import { Text } from '@vkontakte/vkui';
import { clsx } from 'clsx';

import { useWidget } from '../../context/WidgetContext';

import styles from './styles.module.css';

interface Props {
  error?: string | null;
}

export const ErrorNotify = ({ error }: Props) => {
  const { setError } = useWidget();
  const [isShow, setIsShow] = useState(Boolean(error));

  const handleCloseNotify = () => {
    setIsShow(false);
  };

  const handleTransitionEnd = (): void => {
    if (error && !isShow) {
      setError?.(null);
    }
  };

  useEffect(() => {
    setIsShow(Boolean(error));
  }, [error]);

  return (
    <div
      className={clsx(styles.errorNotify, {
        [styles.visible]: isShow,
      })}
      onTransitionEnd={handleTransitionEnd}
    >
      <Text>{error}</Text>
      <Icon24Cancel className={styles.closeButton} onClick={handleCloseNotify} />
    </div>
  );
};
